<!-- eslint-disable max-len -->
<template>
  <div>
    <LoadingSpinner v-if="loading" />
    <div class="block relative w-full mt-2">
      <div class="block relative pl-4 pr-4">
        <div class="block relative mb-2 form-group">
          <label class="block relative text-lgg mb-2 font-bold">
            {{ $t("pages.applications.title") }}
          </label>
          <div class="ds-cunstome-picker">
            <div class="flex items-center justify-start">
              <div class="w-10/12">
                <div
                  class="
                    flex
                    items-center
                    justify-start
                    border
                    solid
                    border-color
                    rounded
                    h-11
                    relatives
                    datepicker-main
                    date-inputgroup
                  "
                >
                  <span
                    class="
                      input-group-addon
                      flex
                      items-center
                      justify-center
                      h-full
                      absolute
                      left-0
                      pl-2
                      pr-2
                      z-10
                    "
                  >
                    <img
                      src="./../../assets/images/calender.png"
                      alt="Date Picker Image"
                    />
                  </span>
                  <datepicker
                    v-model="date"
                    input-class="block border-none outline-none box-shadow-none w-full    text-sm bg-transparent pl-11 h-11"
                    :placeholder="$t('pages.landing.input.placeholder')"
                    :language="lang"
                    format="dd.MM.yyyy"
                    :highlighted="highlighted"
                    :disabled-dates="{ from: new Date() }"
                    @input="inputDate"
                    @selected="selectedDate"
                  />
                </div>
              </div>

              <div class="w-2/12 pl-4 pr-0">
                <button
                  class="
                    relative
                    flex
                    items-center
                    justify-center
                    flex-nowrap
                    text-darkblack text-sm
                    walter-footer
                    p-1.5
                    border
                    solid
                    border-darkgreen
                    rounded
                    w-full
                    text-center
                    bg-darkgreen
                    h-11
                  "
                  @click="showModel = true"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.25 0C0.568203 0 0 0.568203 0 1.25V2.79492C0 3.94325 0.527739 5.02942 1.42969 5.74023L6.5 9.73535V17.25C6.50007 17.3877 6.53806 17.5228 6.60981 17.6404C6.68155 17.7579 6.78429 17.8535 6.90674 17.9165C7.0292 17.9796 7.16665 18.0077 7.30403 17.9978C7.44141 17.9879 7.5734 17.9403 7.68555 17.8604L11.1855 15.3604C11.2828 15.291 11.362 15.1994 11.4167 15.0933C11.4714 14.9871 11.5 14.8694 11.5 14.75V9.73438L16.5703 5.74023C17.4723 5.02942 18 3.94325 18 2.79492V1.25C18 0.568203 17.4318 0 16.75 0H1.25ZM1.5 1.5H16.5V2.79492C16.5 3.4846 16.1846 4.13434 15.6426 4.56152L10.6436 8.5H7.35645L2.35742 4.56152C1.81537 4.13434 1.5 3.4846 1.5 2.79492V1.5ZM8 10H10V14.3643L8 15.793V10Z"
                      fill="white"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>



        <div class="form-group block relative mt-2 mb-2">
          <label
            class="
              block
              relative
              flex
              items-center
              justify-start
              text-sm
              font-medium
              pt-0
              pb-2
            "
            @click="showFilterBox = !showFilterBox"
          >
            {{ $t("pages.applications.sort") }}
            <span v-if="!showFilterBox" class="flex ml-2.5">
              <svg
                class="w-3 h-3"
                viewBox="0 0 16 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.4957 0.992327C14.3637 0.995445 14.2382 1.05068 14.1467 1.14597L8.00025 7.29246L1.85377 1.14597C1.80716 1.09798 1.7514 1.05982 1.68978 1.03377C1.62817 1.00771 1.56195 0.994283 1.49505 0.99428C1.39554 0.994304 1.2983 1.02402 1.21577 1.07961C1.13325 1.13521 1.06919 1.21417 1.03178 1.30638C0.994383 1.39859 0.985343 1.49986 1.00582 1.59724C1.0263 1.69462 1.07536 1.78367 1.14674 1.853L7.64674 8.353C7.74051 8.44674 7.86767 8.49939 8.00025 8.49939C8.13284 8.49939 8.26 8.44674 8.35377 8.353L14.8538 1.853C14.9265 1.78322 14.9764 1.69309 14.997 1.59444C15.0176 1.49578 15.0079 1.39321 14.9692 1.30016C14.9305 1.20711 14.8646 1.12793 14.7801 1.073C14.6956 1.01807 14.5964 0.989947 14.4957 0.992327Z"
                  fill="#63B15B"
                />
              </svg>
            </span>
            <span v-if="showFilterBox" class="flex ml-2.5">
              <svg
                class="w-3 h-3"
                width="16"
                height="9"
                viewBox="0 0 16 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.4955 8.00767C14.3634 8.00455 14.238 7.94932 14.1465 7.85403L8.00001 1.70754L1.85353 7.85403C1.80692 7.90202 1.75116 7.94018 1.68954 7.96623C1.62792 7.99229 1.5617 8.00572 1.4948 8.00572C1.39529 8.0057 1.29806 7.97598 1.21553 7.92039C1.133 7.86479 1.06894 7.78583 1.03154 7.69362C0.994139 7.60141 0.985099 7.50014 1.00558 7.40276C1.02605 7.30538 1.07512 7.21633 1.14649 7.147L7.64649 0.646997C7.74027 0.553264 7.86742 0.50061 8.00001 0.50061C8.1326 0.50061 8.25975 0.553264 8.35353 0.646997L14.8535 7.147C14.9262 7.21678 14.9762 7.30691 14.9968 7.40556C15.0174 7.50422 15.0077 7.60679 14.969 7.69984C14.9302 7.79289 14.8643 7.87207 14.7798 7.927C14.6953 7.98193 14.5962 8.01005 14.4955 8.00767V8.00767Z"
                  fill="#63B15B"
                />
              </svg>
            </span>
          </label>
          <div
            v-if="showFilterBox"
            class="
              absolute
              top-100
              left-0
              w-64
              bg-white
              rounded-lg
              walter-shadow
              z-50
            "
          >
            <ul class="block w-full h-full p-4 m-0">
              <li
                class="nav-item w-full mb-0"
                @click="
                  $store.commit('application/setOrderBy', 'new');
                  fetchList();
                "
              >
                <a class="nav-link flex items-center justify-between pt-1 pb-1">
                  <span
                    :class="
                      sort === 'new'
                        ? 'text-darkgray1 font-bold'
                        : 'text-darkgray font-medium'
                    "
                    class="text pr-1 text-sm"
                  >
                    {{ $t("pages.applications.sorting.newFirst") }}
                  </span>
                  <span v-if="sort === 'new'" class="icons">
                    <svg
                      width="14"
                      height="10"
                      class="w-3 h-3"
                      viewBox="0 0 14 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.3896 0.194568C13.251 0.198696 13.1195 0.256605 13.0229 0.356026L4.86668 8.51228L1.51043 5.15603C1.46128 5.10484 1.40242 5.06398 1.33729 5.03582C1.27215 5.00767 1.20205 4.9928 1.1311 4.99208C1.06014 4.99135 0.989758 5.0048 0.924063 5.03162C0.858368 5.05844 0.798686 5.0981 0.748511 5.14827C0.698335 5.19845 0.658676 5.25813 0.631855 5.32383C0.605034 5.38952 0.591591 5.45991 0.592313 5.53086C0.593035 5.60182 0.607907 5.67192 0.636059 5.73705C0.664211 5.80219 0.705077 5.86105 0.756262 5.91019L4.4896 9.64353C4.58962 9.74351 4.72525 9.79967 4.86668 9.79967C5.0081 9.79967 5.14374 9.74351 5.24376 9.64353L13.7771 1.11019C13.8542 1.03528 13.9068 0.938831 13.9281 0.833487C13.9494 0.728143 13.9384 0.618818 13.8965 0.519839C13.8546 0.42086 13.7838 0.336845 13.6934 0.278802C13.6029 0.22076 13.497 0.1914 13.3896 0.194568Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </span>
                </a>
              </li>

              <li
                class="nav-item w-full mb-0"
                @click="
                  $store.commit('application/setOrderBy', 'old');
                  fetchList();
                "
              >
                <a class="nav-link flex items-center justify-between pt-1 pb-1">
                  <span
                    :class="
                      sort === 'old'
                        ? 'text-darkgray1 font-bold'
                        : 'text-darkgray font-medium'
                    "
                    class="text pr-1 text-sm"
                  >
                    {{ $t("pages.applications.sorting.oldFirst") }}
                  </span>
                  <span v-if="sort === 'old'" class="icons">
                    <svg
                      width="14"
                      height="10"
                      class="w-3 h-3"
                      viewBox="0 0 14 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.3896 0.194568C13.251 0.198696 13.1195 0.256605 13.0229 0.356026L4.86668 8.51228L1.51043 5.15603C1.46128 5.10484 1.40242 5.06398 1.33729 5.03582C1.27215 5.00767 1.20205 4.9928 1.1311 4.99208C1.06014 4.99135 0.989758 5.0048 0.924063 5.03162C0.858368 5.05844 0.798686 5.0981 0.748511 5.14827C0.698335 5.19845 0.658676 5.25813 0.631855 5.32383C0.605034 5.38952 0.591591 5.45991 0.592313 5.53086C0.593035 5.60182 0.607907 5.67192 0.636059 5.73705C0.664211 5.80219 0.705077 5.86105 0.756262 5.91019L4.4896 9.64353C4.58962 9.74351 4.72525 9.79967 4.86668 9.79967C5.0081 9.79967 5.14374 9.74351 5.24376 9.64353L13.7771 1.11019C13.8542 1.03528 13.9068 0.938831 13.9281 0.833487C13.9494 0.728143 13.9384 0.618818 13.8965 0.519839C13.8546 0.42086 13.7838 0.336845 13.6934 0.278802C13.6029 0.22076 13.497 0.1914 13.3896 0.194568Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </span>
                </a>
              </li>

              <li
                class="nav-item w-full mb-0"
                @click="
                  $store.commit('application/setOrderBy', 'increasing-budget');
                  fetchList();
                "
              >
                <a class="nav-link flex items-center justify-between pt-1 pb-1">
                  <span
                    :class="
                      sort === 'increasing-budget'
                        ? 'text-darkgray1 font-bold'
                        : 'text-darkgray font-medium'
                    "
                    class="text pr-1 text-sm"
                  >
                    {{ $t("pages.applications.sorting.increasingBudget") }}
                  </span>
                  <span v-if="sort === 'increasing-budget'" class="icons">
                    <svg
                      width="14"
                      height="10"
                      class="w-3 h-3"
                      viewBox="0 0 14 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.3896 0.194568C13.251 0.198696 13.1195 0.256605 13.0229 0.356026L4.86668 8.51228L1.51043 5.15603C1.46128 5.10484 1.40242 5.06398 1.33729 5.03582C1.27215 5.00767 1.20205 4.9928 1.1311 4.99208C1.06014 4.99135 0.989758 5.0048 0.924063 5.03162C0.858368 5.05844 0.798686 5.0981 0.748511 5.14827C0.698335 5.19845 0.658676 5.25813 0.631855 5.32383C0.605034 5.38952 0.591591 5.45991 0.592313 5.53086C0.593035 5.60182 0.607907 5.67192 0.636059 5.73705C0.664211 5.80219 0.705077 5.86105 0.756262 5.91019L4.4896 9.64353C4.58962 9.74351 4.72525 9.79967 4.86668 9.79967C5.0081 9.79967 5.14374 9.74351 5.24376 9.64353L13.7771 1.11019C13.8542 1.03528 13.9068 0.938831 13.9281 0.833487C13.9494 0.728143 13.9384 0.618818 13.8965 0.519839C13.8546 0.42086 13.7838 0.336845 13.6934 0.278802C13.6029 0.22076 13.497 0.1914 13.3896 0.194568Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </span>
                </a>
              </li>

              <li
                class="nav-item w-full mb-0"
                @click="
                  $store.commit('application/setOrderBy', 'decreasing-budget');
                  fetchList();
                "
              >
                <a class="nav-link flex items-center justify-between pt-1 pb-1">
                  <span
                    :class="
                      sort === 'decreasing-budget'
                        ? 'text-darkgray1 font-bold'
                        : 'text-darkgray font-medium'
                    "
                    class="text pr-1 text-sm"
                  >
                    {{ $t("pages.applications.sorting.decreasingBudget") }}
                  </span>
                  <span v-if="sort === 'decreasing-budget'" class="icons">
                    <svg
                      width="14"
                      height="10"
                      class="w-3 h-3"
                      viewBox="0 0 14 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.3896 0.194568C13.251 0.198696 13.1195 0.256605 13.0229 0.356026L4.86668 8.51228L1.51043 5.15603C1.46128 5.10484 1.40242 5.06398 1.33729 5.03582C1.27215 5.00767 1.20205 4.9928 1.1311 4.99208C1.06014 4.99135 0.989758 5.0048 0.924063 5.03162C0.858368 5.05844 0.798686 5.0981 0.748511 5.14827C0.698335 5.19845 0.658676 5.25813 0.631855 5.32383C0.605034 5.38952 0.591591 5.45991 0.592313 5.53086C0.593035 5.60182 0.607907 5.67192 0.636059 5.73705C0.664211 5.80219 0.705077 5.86105 0.756262 5.91019L4.4896 9.64353C4.58962 9.74351 4.72525 9.79967 4.86668 9.79967C5.0081 9.79967 5.14374 9.74351 5.24376 9.64353L13.7771 1.11019C13.8542 1.03528 13.9068 0.938831 13.9281 0.833487C13.9494 0.728143 13.9384 0.618818 13.8965 0.519839C13.8546 0.42086 13.7838 0.336845 13.6934 0.278802C13.6029 0.22076 13.497 0.1914 13.3896 0.194568Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>



        <div
            v-if="applications.length === 0"
            class=""
        >
          <div
              class="offerno_result"
              style="
                    display: block;
                    position: relative;
                    padding: 20px 20px 20px;
                  "
              v-if="!loading"
          >
            <div class="flex items-center justify-center iconbox">

            </div>
            <h5 style="text-align: center">
              {{ $t("pages.offers.no_result.heading") }}
            </h5>
            <p class="font-normal" style="text-align: center">
              {{ $t("pages.offers.no_result.description") }}
            </p>
            <p>
              <a
                  style="display: block; text-align: center;cursor: pointer;  margin: 0 auto"
                  class="reset_fill"
                  @click="resetFilter"
              >
                {{ $t("pages.common.buttons.dis150") }}
              </a>
            </p>
          </div>
        </div>
        <div
          v-for="(application, key) in applications"
          :key="`application_${key}`"
          class="list-items block relative"
        >
          <div
            v-if="!loading"
            class="
              block
              relative
              walter-block
              bg-white
              rounded-lg
              walter-shadow
              mb-4
            "
            @click="redirect(application)"
          >
            <div class="flex top-block mb-0 pt-4 pb-3 pl-4 pr-4">
              <div class="left-block w-2/4 relative">
                <div class="flex items-center">
                  <h4 class="block relative text-sm font-bold text-darkblack">
                    {{ application.offer.customer.last_name }}/{{
                      application.offer.customer.first_name
                    }}
                  </h4>

                </div>

                <p
                  class="
                    flex
                    align-center
                    justify-start
                    mb-0
                    mt-2
                    text-xs
                    font-medium
                    text-darkgray1
                  "
                >
                  <span class="mr-1">
                    <svg
                      class="w-2.5 h-2.5"
                      viewBox="0 0 10 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.99984 0.666992C2.2667 0.666992 0.0415039 2.89219 0.0415039 5.62533C0.0415039 6.85231 0.491635 7.97757 1.23096 8.84277L1.23324 8.84505L1.23494 8.84733C1.23494 8.84733 3.34426 11.2542 4.09522 11.9708C4.59809 12.4502 5.40102 12.4502 5.90389 11.9708C6.75987 11.1544 8.7653 8.84619 8.7653 8.84619L8.76644 8.84448L8.76815 8.84277C9.50813 7.97756 9.95817 6.85231 9.95817 5.62533C9.95817 2.89219 7.73297 0.666992 4.99984 0.666992ZM4.99984 1.54199C7.26004 1.54199 9.08317 3.36513 9.08317 5.62533C9.08317 6.63893 8.71379 7.55983 8.10278 8.27425C8.09881 8.2788 6.04693 10.6255 5.30005 11.3379C5.12684 11.503 4.87227 11.503 4.69906 11.3379C4.07484 10.7423 1.90266 8.28143 1.89632 8.27425L1.89575 8.27368C1.28556 7.55932 0.916504 6.63865 0.916504 5.62533C0.916504 3.36513 2.73964 1.54199 4.99984 1.54199ZM4.99984 3.87533C4.45296 3.87533 3.98741 4.09616 3.68848 4.43245C3.38955 4.76875 3.24984 5.19998 3.24984 5.62533C3.24984 6.05067 3.38955 6.4819 3.68848 6.8182C3.98741 7.15449 4.45296 7.37533 4.99984 7.37533C5.54671 7.37533 6.01227 7.15449 6.3112 6.8182C6.61013 6.4819 6.74984 6.05067 6.74984 5.62533C6.74984 5.19998 6.61013 4.76875 6.3112 4.43245C6.01227 4.09616 5.54671 3.87533 4.99984 3.87533ZM4.99984 4.75033C5.32796 4.75033 5.51866 4.85762 5.65723 5.01351C5.7958 5.1694 5.87484 5.39442 5.87484 5.62533C5.87484 5.85623 5.7958 6.08125 5.65723 6.23714C5.51866 6.39303 5.32796 6.50033 4.99984 6.50033C4.67171 6.50033 4.48102 6.39303 4.34245 6.23714C4.20388 6.08125 4.12484 5.85623 4.12484 5.62533C4.12484 5.39442 4.20388 5.1694 4.34245 5.01351C4.48102 4.85762 4.67171 4.75033 4.99984 4.75033Z"
                        fill="#676666"
                      />
                    </svg>
                  </span>


                  {{ application.offer.location }}
                </p>


              </div>

              <div class="right-block w-2/4 relative">
                <p
                  class="
                    wishlist-icon
                    relative
                    text-smm text-right
                    flex
                    items-center
                    justify-end
                    font-bold
                  "
                >
                  <span class="flex mr-1.5">
                    <svg
                      class="w-3.5 h-3.5"
                      viewBox="0 0 12 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.00016 0.833008C3.32418 0.833008 0.333496 3.8237 0.333496 7.49967C0.333496 11.1757 3.32418 14.1663 7.00016 14.1663C10.6761 14.1663 13.6668 11.1757 13.6668 7.49967C13.6668 3.8237 10.6761 0.833008 7.00016 0.833008ZM7.17334 3.83301C8.49667 3.83301 9.06307 4.39182 9.51774 4.84082C9.71441 5.03482 9.7163 5.35118 9.5223 5.54785C9.32863 5.74452 9.01127 5.74641 8.81527 5.55241C8.40827 5.15074 8.08699 4.83301 7.17399 4.83301C6.37166 4.83301 5.67077 5.37067 5.29443 6.16634H6.8335C7.1095 6.16634 7.3335 6.39001 7.3335 6.66634C7.3335 6.94267 7.1095 7.16634 6.8335 7.16634H5.01904C5.00771 7.27567 5.00016 7.38667 5.00016 7.49967C5.00016 7.61267 5.00771 7.72367 5.01904 7.83301H6.8335C7.1095 7.83301 7.3335 8.05667 7.3335 8.33301C7.3335 8.60934 7.1095 8.83301 6.8335 8.83301H5.29443C5.6711 9.62867 6.37101 10.1663 7.17334 10.1663C8.08634 10.1663 8.40793 9.84861 8.81527 9.44694C9.01127 9.25294 9.32863 9.25516 9.5223 9.4515C9.7163 9.64816 9.71441 9.96486 9.51774 10.1585C9.06307 10.6079 8.49699 11.1663 7.17399 11.1663C5.83132 11.1663 4.68353 10.1967 4.22087 8.83301H3.50016C3.22416 8.83301 3.00016 8.60934 3.00016 8.33301C3.00016 8.05667 3.22416 7.83301 3.50016 7.83301H4.01514C4.00647 7.72301 4.00016 7.61234 4.00016 7.49967C4.00016 7.38701 4.00647 7.27634 4.01514 7.16634H3.50016C3.22416 7.16634 3.00016 6.94267 3.00016 6.66634C3.00016 6.39001 3.22416 6.16634 3.50016 6.16634H4.22021C4.68322 4.80267 5.83101 3.83301 7.17334 3.83301Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </span>
                  {{ formatPrice(application.offer.compensation) }} Euro
                </p>
                <p
                  class="
                    flex
                    align-center
                    justify-end
                    mt-2
                    mb-0
                    text-xs
                    font-medium
                    text-darkgray1
                  "
                >
                  {{ $t("pages.common.buttons.dis15") }}
                  {{
                    formatDate(
                      application.offer.arrival_date,
                      "DD.MM.YYYY",
                      "YYYY-MM-DD"
                    )
                  }}
                </p>
              </div>
            </div>
            <div
              v-if="application.status === 'nurse'"
              class="
                flex
                items-center
                justify-start
                relative
                pt-3
                pb-3
                pl-3
                pr-3
                bg-lightpink
                text-darkblack text-xs
                walter-footer
                flex-wrap
              "
            >
              <span class="icon mr-1">
                <svg
                  class="w-3 h-3"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.1622 0.326311C11.0301 0.32943 10.9047 0.384665 10.8132 0.479957L6.00008 5.29311L1.18693 0.479957C1.14032 0.431962 1.08456 0.393806 1.02294 0.36775C0.961323 0.341694 0.895103 0.328267 0.828203 0.328265C0.728696 0.328289 0.631458 0.358001 0.548932 0.413598C0.466406 0.469196 0.402343 0.548151 0.364942 0.640362C0.32754 0.732572 0.3185 0.833845 0.338978 0.931222C0.359456 1.0286 0.408521 1.11765 0.479896 1.18699L5.29305 6.00014L0.479896 10.8133C0.43191 10.8594 0.393599 10.9146 0.367208 10.9756C0.340816 11.0367 0.326874 11.1024 0.326198 11.1689C0.325521 11.2354 0.338125 11.3014 0.363269 11.363C0.388414 11.4246 0.425594 11.4805 0.472633 11.5276C0.519672 11.5746 0.575624 11.6118 0.637212 11.637C0.6988 11.6621 0.764786 11.6747 0.831306 11.674C0.897825 11.6733 0.963542 11.6594 1.02461 11.633C1.08567 11.6066 1.14085 11.5683 1.18693 11.5203L6.00008 6.70717L10.8132 11.5203C10.8593 11.5683 10.9145 11.6066 10.9755 11.633C11.0366 11.6594 11.1023 11.6733 11.1688 11.674C11.2354 11.6747 11.3014 11.6621 11.3629 11.6369C11.4245 11.6118 11.4805 11.5746 11.5275 11.5276C11.5746 11.4805 11.6117 11.4246 11.6369 11.363C11.662 11.3014 11.6746 11.2354 11.674 11.1689C11.6733 11.1024 11.6593 11.0367 11.6329 10.9756C11.6066 10.9146 11.5682 10.8594 11.5203 10.8133L6.70711 6.00014L11.5203 1.18699C11.593 1.1172 11.6429 1.02707 11.6635 0.928421C11.6841 0.829768 11.6744 0.727192 11.6357 0.634143C11.597 0.541094 11.531 0.461913 11.4466 0.406981C11.3621 0.35205 11.2629 0.323931 11.1622 0.326311Z"
                    fill="#EE5B64"
                  />
                </svg>
              </span>
              <span class="text-xs text-smallxs mr-1 text-darkblack font-bold">
                {{ $t("pages.common.buttons.dis14") }}
              </span>
            </div>

            <div
              v-else-if="application.status === 'rejected_by_customer'"
              class="
                flex
                items-center
                justify-start
                relative
                pt-3
                pb-3
                pl-3
                pr-3
                bg-lightpink
                text-darkblack text-xs
                walter-footer
                flex-wrap
              "
            >
              <span class="icon mr-1">
                <svg
                  class="w-3 h-3"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.1622 0.326311C11.0301 0.32943 10.9047 0.384665 10.8132 0.479957L6.00008 5.29311L1.18693 0.479957C1.14032 0.431962 1.08456 0.393806 1.02294 0.36775C0.961323 0.341694 0.895103 0.328267 0.828203 0.328265C0.728696 0.328289 0.631458 0.358001 0.548932 0.413598C0.466406 0.469196 0.402343 0.548151 0.364942 0.640362C0.32754 0.732572 0.3185 0.833845 0.338978 0.931222C0.359456 1.0286 0.408521 1.11765 0.479896 1.18699L5.29305 6.00014L0.479896 10.8133C0.43191 10.8594 0.393599 10.9146 0.367208 10.9756C0.340816 11.0367 0.326874 11.1024 0.326198 11.1689C0.325521 11.2354 0.338125 11.3014 0.363269 11.363C0.388414 11.4246 0.425594 11.4805 0.472633 11.5276C0.519672 11.5746 0.575624 11.6118 0.637212 11.637C0.6988 11.6621 0.764786 11.6747 0.831306 11.674C0.897825 11.6733 0.963542 11.6594 1.02461 11.633C1.08567 11.6066 1.14085 11.5683 1.18693 11.5203L6.00008 6.70717L10.8132 11.5203C10.8593 11.5683 10.9145 11.6066 10.9755 11.633C11.0366 11.6594 11.1023 11.6733 11.1688 11.674C11.2354 11.6747 11.3014 11.6621 11.3629 11.6369C11.4245 11.6118 11.4805 11.5746 11.5275 11.5276C11.5746 11.4805 11.6117 11.4246 11.6369 11.363C11.662 11.3014 11.6746 11.2354 11.674 11.1689C11.6733 11.1024 11.6593 11.0367 11.6329 10.9756C11.6066 10.9146 11.5682 10.8594 11.5203 10.8133L6.70711 6.00014L11.5203 1.18699C11.593 1.1172 11.6429 1.02707 11.6635 0.928421C11.6841 0.829768 11.6744 0.727192 11.6357 0.634143C11.597 0.541094 11.531 0.461913 11.4466 0.406981C11.3621 0.35205 11.2629 0.323931 11.1622 0.326311Z"
                    fill="#EE5B64"
                  />
                </svg>
              </span>
              <span class="text-xs text-smallxs mr-1 text-darkblack font-bold">
                {{ $t("pages.applications.rejected_by_customers") }}
              </span>
            </div>
            <div
              v-else-if="application.status === 'accepted'"
              class="
                flex
                items-center
                justify-start
                relative
                pt-3
                pb-3
                pl-3
                pr-3
                bg-lightgreen
                text-darkblack text-xs
                walter-footer
                flex-wrap
              "
            >
              <span class="icon mr-1">
                <svg
                  class="w-3 h-3"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.9464 1.14028C10.8847 1.07847 10.8115 1.02944 10.7308 0.995987C10.6502 0.962533 10.5637 0.945312 10.4764 0.945312C10.3891 0.945313 10.3026 0.962533 10.222 0.995987C10.1413 1.02944 10.0681 1.07847 10.0064 1.14028L4.35308 6.80028L1.99308 4.44028C1.86843 4.31562 1.69936 4.24559 1.52308 4.24559C1.34679 4.24559 1.17773 4.31562 1.05308 4.44028C0.928427 4.56493 0.858398 4.73399 0.858398 4.91028C0.858398 4.99756 0.875591 5.08399 0.908994 5.16464C0.942397 5.24528 0.991357 5.31855 1.05308 5.38028L3.87975 8.20694C4.13975 8.46694 4.55975 8.46694 4.81975 8.20694L10.9464 2.08028C11.2131 1.82028 11.2131 1.40028 10.9464 1.14028ZM1.99975 11.3336H9.99975C10.3664 11.3336 10.6664 11.0336 10.6664 10.6669C10.6664 10.3003 10.3664 10.0003 9.99975 10.0003H1.99975C1.63308 10.0003 1.33308 10.3003 1.33308 10.6669C1.33308 11.0336 1.63308 11.3336 1.99975 11.3336Z"
                    fill="#63B15B"
                  />
                </svg>
              </span>
              <span class="text-xs text-smallxs mr-1 text-darkblack font-bold">
                {{ $t("pages.common.buttons.dis11") }}
              </span>
            </div>
            <div
              v-else-if="application.status === 'rejected_by_pk'"
              class="
                flex
                items-center
                justify-start
                relative
                pt-3
                pb-3
                pl-3
                pr-3
                bg-lightpink
                text-darkblack text-xs
                walter-footer
                flex-wrap
              "
            >
              <span class="icon mr-1">
                <svg
                  class="w-3 h-3"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.1622 0.326311C11.0301 0.32943 10.9047 0.384665 10.8132 0.479957L6.00008 5.29311L1.18693 0.479957C1.14032 0.431962 1.08456 0.393806 1.02294 0.36775C0.961323 0.341694 0.895103 0.328267 0.828203 0.328265C0.728696 0.328289 0.631458 0.358001 0.548932 0.413598C0.466406 0.469196 0.402343 0.548151 0.364942 0.640362C0.32754 0.732572 0.3185 0.833845 0.338978 0.931222C0.359456 1.0286 0.408521 1.11765 0.479896 1.18699L5.29305 6.00014L0.479896 10.8133C0.43191 10.8594 0.393599 10.9146 0.367208 10.9756C0.340816 11.0367 0.326874 11.1024 0.326198 11.1689C0.325521 11.2354 0.338125 11.3014 0.363269 11.363C0.388414 11.4246 0.425594 11.4805 0.472633 11.5276C0.519672 11.5746 0.575624 11.6118 0.637212 11.637C0.6988 11.6621 0.764786 11.6747 0.831306 11.674C0.897825 11.6733 0.963542 11.6594 1.02461 11.633C1.08567 11.6066 1.14085 11.5683 1.18693 11.5203L6.00008 6.70717L10.8132 11.5203C10.8593 11.5683 10.9145 11.6066 10.9755 11.633C11.0366 11.6594 11.1023 11.6733 11.1688 11.674C11.2354 11.6747 11.3014 11.6621 11.3629 11.6369C11.4245 11.6118 11.4805 11.5746 11.5275 11.5276C11.5746 11.4805 11.6117 11.4246 11.6369 11.363C11.662 11.3014 11.6746 11.2354 11.674 11.1689C11.6733 11.1024 11.6593 11.0367 11.6329 10.9756C11.6066 10.9146 11.5682 10.8594 11.5203 10.8133L6.70711 6.00014L11.5203 1.18699C11.593 1.1172 11.6429 1.02707 11.6635 0.928421C11.6841 0.829768 11.6744 0.727192 11.6357 0.634143C11.597 0.541094 11.531 0.461913 11.4466 0.406981C11.3621 0.35205 11.2629 0.323931 11.1622 0.326311Z"
                    fill="#EE5B64"
                  />
                </svg>
              </span>
              <span class="text-xs text-smallxs mr-1 text-darkblack font-bold">
                {{ $t("pages.common.buttons.dis13") }}
              </span>
            </div>
            <div
              v-else-if="application.status === 'applied'"
              class="
                flex
                items-center
                justify-start
                relative
                pt-3
                pb-3
                pl-3
                pr-3
                bg-lightgray
                text-darkblack text-xs
                walter-footer
                flex-wrap
              "
            >
              <span class="icon mr-1">
                <svg
                  class="w-3 h-3"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 2C4.6875 2 2 4.6875 2 8C2 11.3125 4.6875 14 8 14C11.3125 14 14 11.3125 14 8C14 4.6875 11.3125 2 8 2Z"
                    stroke="#333333"
                    stroke-miterlimit="10"
                  />
                  <path
                    d="M8 4V8.5H11"
                    stroke="#333333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <span class="text-xs text-smallxs mr-1 text-darkblack font-bold">
                {{ $t("pages.common.buttons.dis10") }}
              </span>
            </div>

            <div
              v-else-if="application.status === 'expired'"
              class="
                flex
                items-center
                justify-start
                relative
                pt-3
                pb-3
                pl-3
                pr-3
                bg-lightgrayblack
                text-darkblack text-xs
                walter-footer
                flex-wrap
              "
            >
              <span class="icon mr-1">
                <svg
                  class="w-3 h-3"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 0.5C3.41594 0.5 0.5 3.41594 0.5 7C0.5 10.5841 3.41594 13.5 7 13.5C10.5841 13.5 13.5 10.5841 13.5 7C13.5 3.41594 10.5841 0.5 7 0.5ZM9.35344 8.64656C9.40182 8.69253 9.44051 8.74772 9.46723 8.80888C9.49395 8.87003 9.50816 8.93592 9.50901 9.00265C9.50986 9.06938 9.49735 9.13561 9.47221 9.19743C9.44706 9.25925 9.4098 9.31541 9.36261 9.36261C9.31541 9.4098 9.25925 9.44706 9.19743 9.47221C9.13561 9.49735 9.06938 9.50986 9.00265 9.50901C8.93592 9.50816 8.87003 9.49395 8.80888 9.46723C8.74772 9.44051 8.69253 9.40182 8.64656 9.35344L7 7.70719L5.35344 9.35344C5.25891 9.44325 5.13303 9.49258 5.00265 9.49091C4.87227 9.48924 4.7477 9.4367 4.6555 9.3445C4.5633 9.2523 4.51076 9.12773 4.50909 8.99735C4.50742 8.86697 4.55675 8.74109 4.64656 8.64656L6.29281 7L4.64656 5.35344C4.55675 5.25891 4.50742 5.13303 4.50909 5.00265C4.51076 4.87227 4.5633 4.7477 4.6555 4.6555C4.7477 4.5633 4.87227 4.51076 5.00265 4.50909C5.13303 4.50742 5.25891 4.55675 5.35344 4.64656L7 6.29281L8.64656 4.64656C8.74109 4.55675 8.86697 4.50742 8.99735 4.50909C9.12773 4.51076 9.2523 4.5633 9.3445 4.6555C9.4367 4.7477 9.48924 4.87227 9.49091 5.00265C9.49258 5.13303 9.44325 5.25891 9.35344 5.35344L7.70719 7L9.35344 8.64656Z"
                    fill="white"
                  />
                </svg>
              </span>
              <span class="text-xs text-smallxs mr-1 font-bold text-white">
                {{ $t("pages.common.buttons.dis9") }}
              </span>
            </div>
             <div
              v-else-if="application.status === 'denied'"
              class="
                flex
                items-center
                justify-start
                relative
                pt-3
                pb-3
                pl-3
                pr-3
                bg-lightpink
                text-darkblack text-xs
                walter-footer
                flex-wrap
              "
            >
              <span class="icon mr-1">
                <svg
                  class="w-3 h-3"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 0.5C3.41594 0.5 0.5 3.41594 0.5 7C0.5 10.5841 3.41594 13.5 7 13.5C10.5841 13.5 13.5 10.5841 13.5 7C13.5 3.41594 10.5841 0.5 7 0.5ZM9.35344 8.64656C9.40182 8.69253 9.44051 8.74772 9.46723 8.80888C9.49395 8.87003 9.50816 8.93592 9.50901 9.00265C9.50986 9.06938 9.49735 9.13561 9.47221 9.19743C9.44706 9.25925 9.4098 9.31541 9.36261 9.36261C9.31541 9.4098 9.25925 9.44706 9.19743 9.47221C9.13561 9.49735 9.06938 9.50986 9.00265 9.50901C8.93592 9.50816 8.87003 9.49395 8.80888 9.46723C8.74772 9.44051 8.69253 9.40182 8.64656 9.35344L7 7.70719L5.35344 9.35344C5.25891 9.44325 5.13303 9.49258 5.00265 9.49091C4.87227 9.48924 4.7477 9.4367 4.6555 9.3445C4.5633 9.2523 4.51076 9.12773 4.50909 8.99735C4.50742 8.86697 4.55675 8.74109 4.64656 8.64656L6.29281 7L4.64656 5.35344C4.55675 5.25891 4.50742 5.13303 4.50909 5.00265C4.51076 4.87227 4.5633 4.7477 4.6555 4.6555C4.7477 4.5633 4.87227 4.51076 5.00265 4.50909C5.13303 4.50742 5.25891 4.55675 5.35344 4.64656L7 6.29281L8.64656 4.64656C8.74109 4.55675 8.86697 4.50742 8.99735 4.50909C9.12773 4.51076 9.2523 4.5633 9.3445 4.6555C9.4367 4.7477 9.48924 4.87227 9.49091 5.00265C9.49258 5.13303 9.44325 5.25891 9.35344 5.35344L7.70719 7L9.35344 8.64656Z"
                    fill="white"
                  />
                </svg>
              </span>
              <span class="text-xs text-smallxs mr-1 font-bold text-black">
                {{ $t("pages.common.buttons.dis23") }}
              </span>
            </div>
            <div
              v-else-if="application.status === 'past'"
              class="
                flex
                items-center
                justify-start
                relative
                pt-3
                pb-3
                pl-3
                pr-3
             
                text-darkblack text-xs
                walter-footer
                flex-wrap
              "
              style="background-color: #D7E4FF"
            >
             <i class="fas fa-users"></i>
              <span class="icon mr-1">

                <svg
                  class="w-3 h-3"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
               
                  
                </svg>
              </span>
              <span class="text-xs text-smallxs mr-1 font-bold text-black">
                {{ $t("pages.applications.filter.past") }}
              </span>
            </div>
            <div
              v-else
              class="
                flex
                items-center
                justify-start
                relative
                pt-3
                pb-3
                pl-3
                pr-3
                bg-lightgrayblack
                text-darkblack text-xs
                walter-footer
                flex-wrap
              "
            >
              <span class="icon mr-1">
                <svg
                  class="w-3 h-3"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 0.5C3.41594 0.5 0.5 3.41594 0.5 7C0.5 10.5841 3.41594 13.5 7 13.5C10.5841 13.5 13.5 10.5841 13.5 7C13.5 3.41594 10.5841 0.5 7 0.5ZM9.35344 8.64656C9.40182 8.69253 9.44051 8.74772 9.46723 8.80888C9.49395 8.87003 9.50816 8.93592 9.50901 9.00265C9.50986 9.06938 9.49735 9.13561 9.47221 9.19743C9.44706 9.25925 9.4098 9.31541 9.36261 9.36261C9.31541 9.4098 9.25925 9.44706 9.19743 9.47221C9.13561 9.49735 9.06938 9.50986 9.00265 9.50901C8.93592 9.50816 8.87003 9.49395 8.80888 9.46723C8.74772 9.44051 8.69253 9.40182 8.64656 9.35344L7 7.70719L5.35344 9.35344C5.25891 9.44325 5.13303 9.49258 5.00265 9.49091C4.87227 9.48924 4.7477 9.4367 4.6555 9.3445C4.5633 9.2523 4.51076 9.12773 4.50909 8.99735C4.50742 8.86697 4.55675 8.74109 4.64656 8.64656L6.29281 7L4.64656 5.35344C4.55675 5.25891 4.50742 5.13303 4.50909 5.00265C4.51076 4.87227 4.5633 4.7477 4.6555 4.6555C4.7477 4.5633 4.87227 4.51076 5.00265 4.50909C5.13303 4.50742 5.25891 4.55675 5.35344 4.64656L7 6.29281L8.64656 4.64656C8.74109 4.55675 8.86697 4.50742 8.99735 4.50909C9.12773 4.51076 9.2523 4.5633 9.3445 4.6555C9.4367 4.7477 9.48924 4.87227 9.49091 5.00265C9.49258 5.13303 9.44325 5.25891 9.35344 5.35344L7.70719 7L9.35344 8.64656Z"
                    fill="white"
                  />
                </svg>
              </span>
              <span class="text-xs text-smallxs mr-1 font-bold text-white">
                {{ $t("pages.common.buttons.dis9") }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="showModel"
      class="block fixed top-0 left-0 w-full h-full model-block"
    >
      <div class="flex items-end justify-start model-body w-full h-full">
        <div
          class="
            flex
            items-end
            justify-start
            model-body
            w-full
            h-full
            black-overlay
            absolute
            left-0
            top-0
          "
          @click="filterClose"
        ></div>
        <div class="block w-full bg-white rounded-t-xl relative">
          <div class="body_inners pl-4 pr-4">
            <div
              class="flex items-center justify-between top-block mb-2 pt-4 pb-4"
            >
              <span class="cross-cion" @click="filterClose">
                <svg
                  class="w-4 h-4"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.7433 0.489467C16.5452 0.494145 16.357 0.576998 16.2198 0.719936L9.00012 7.93966L1.78039 0.719936C1.71048 0.647943 1.62684 0.59071 1.53441 0.551626C1.44198 0.512541 1.34265 0.492401 1.2423 0.492397C1.09304 0.492433 0.947187 0.537001 0.823398 0.620397C0.699609 0.703794 0.603515 0.822226 0.547413 0.960543C0.49131 1.09886 0.47775 1.25077 0.508468 1.39683C0.539185 1.5429 0.612782 1.67648 0.719843 1.78048L7.93957 9.00021L0.719843 16.2199C0.647865 16.289 0.590399 16.3718 0.550812 16.4634C0.511224 16.555 0.490311 16.6536 0.489297 16.7534C0.488282 16.8531 0.507187 16.9521 0.544904 17.0445C0.58262 17.1369 0.638391 17.2208 0.70895 17.2914C0.779508 17.3619 0.863436 17.4177 0.955818 17.4554C1.0482 17.4931 1.14718 17.512 1.24696 17.511C1.34674 17.51 1.44531 17.4891 1.53691 17.4495C1.6285 17.4099 1.71128 17.3525 1.78039 17.2805L9.00012 10.0608L16.2198 17.2805C16.2889 17.3525 16.3717 17.4099 16.4633 17.4495C16.5549 17.4891 16.6535 17.51 16.7533 17.511C16.8531 17.512 16.952 17.4931 17.0444 17.4554C17.1368 17.4177 17.2207 17.3619 17.2913 17.2914C17.3618 17.2208 17.4176 17.1369 17.4553 17.0445C17.493 16.9521 17.5119 16.8531 17.5109 16.7534C17.5099 16.6536 17.489 16.555 17.4494 16.4634C17.4098 16.3718 17.3524 16.289 17.2804 16.2199L10.0607 9.00021L17.2804 1.78048C17.3895 1.6758 17.4643 1.54061 17.4952 1.39263C17.5261 1.24465 17.5116 1.09079 17.4535 0.951215C17.3955 0.811641 17.2966 0.69287 17.1698 0.610472C17.0431 0.528075 16.8944 0.485897 16.7433 0.489467Z"
                    fill="#676666"
                  />
                </svg>
              </span>
              <label class="block capitalize text-xss text-darkblack font-bold">
                {{ $t("pages.applications.filter.title") }}
              </label>
              <label
                class="
                  flex
                  items-center
                  justify-end
                  text-sm
                  font-medium
                  text-right text-darkgreen
                "
                @click="
                  filters = defaultFilters();
                  filterChanged('');
                "
              >
                {{ $t("pages.applications.filter.button.reset") }}
              </label>
            </div>

            <h2
              class="title block relative text-sm font-bold mb-5 text-darkblack"
            >
              {{ $t("pages.applications.filter.heading") }}
            </h2>

            <div class="block relative mb-6">
              <div class="item relative flex items-center justify-start mb-3">
                <label class="custome_check mr-4 w-5 h-5">
                  <input
                    v-model="filters.active"
                    type="checkbox"
                    @change="filterChanged('active')"
                  />
                  <span class="checkmark"></span>
                </label>
                <label
                  class="block relative text-darkgray1 text-sm font-semibold"
                >
                  {{ $t("pages.applications.filter.active") }}
                </label>
              </div>

              <div class="item relative flex items-center justify-start mb-3">
                <label class="custome_check mr-4 w-5 h-5">
                  <input
                    v-model="filters.rejected"
                    type="checkbox"
                    @change="filterChanged('rejected')"
                  />
                  <span class="checkmark"></span>
                </label>
                <label
                  class="block relative text-darkgray1 text-sm font-semibold"
                >
                  {{ $t("pages.applications.filter.rejected") }}
                </label>
              </div>

              <div class="item relative flex items-center justify-start mb-3">
                <label class="custome_check mr-4 w-5 h-5">
                  <input
                    v-model="filters.expired"
                    type="checkbox"
                    @change="filterChanged('expired')"
                  />
                  <span class="checkmark"></span>
                </label>
                <label
                  class="block relative text-darkgray1 text-sm font-semibold"
                >
                  {{ $t("pages.applications.filter.expired") }}
                </label>
              </div>

              <div class="item relative flex items-center justify-start mb-3">
                <label class="custome_check mr-4 w-5 h-5">
                  <input
                    v-model="filters.past"
                    type="checkbox"
                    @change="filterChanged('past')"
                  />
                  <span class="checkmark"></span>
                </label>
                <label
                  class="block relative text-darkgray1 text-sm font-semibold"
                >
                  {{ $t("pages.applications.filter.past") }}
                </label>
              </div>
            </div>

            <div class="form-group mb-6 w-full">
              <button
                class="
                  w-full
                  flex
                  items-center
                  justify-center
                  btn_apply
                  rounded-lg
                  text-white
                  btn_action
                  font-semibold
                  text-sm
                "
                @click="filterClose()"
              >
                <span class="flex mr-2.5">
                  <svg
                    width="19"
                    height="18"
                    viewBox="0 0 19 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.75 0C1.0682 0 0.5 0.568203 0.5 1.25V2.79492C0.5 3.94325 1.02774 5.02942 1.92969 5.74023L7 9.73535V17.25C7.00007 17.3877 7.03806 17.5228 7.10981 17.6404C7.18155 17.7579 7.28429 17.8535 7.40674 17.9165C7.5292 17.9796 7.66665 18.0077 7.80403 17.9978C7.94141 17.9879 8.0734 17.9403 8.18555 17.8604L11.6855 15.3604C11.7828 15.291 11.862 15.1994 11.9167 15.0933C11.9714 14.9871 12 14.8694 12 14.75V9.73438L17.0703 5.74023C17.9723 5.02942 18.5 3.94325 18.5 2.79492V1.25C18.5 0.568203 17.9318 0 17.25 0H1.75ZM2 1.5H17V2.79492C17 3.4846 16.6846 4.13434 16.1426 4.56152L11.1436 8.5H7.85645L2.85742 4.56152C2.31537 4.13434 2 3.4846 2 2.79492V1.5ZM8.5 10H10.5V14.3643L8.5 15.793V10Z"
                      fill="white"
                    />
                  </svg>
                </span>
                {{ $t("pages.applications.filter.button.save") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { de, pl, en } from "vuejs-datepicker/dist/locale";
import LoadingSpinner from "@/components/LoadingSpinner";

export default {
  name: "Applications",
  components: { LoadingSpinner, Datepicker },
  data() {
    return {
      showModel: false,
      showModal: false,
      showFilterBox: false,
      date: null,
      highlighted: {
        dates: [
          new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate()
          ),
        ],
        includeDisabled: true,
      },
      loading: true,
      filters: this.defaultFilters(),
    };
  },
  computed: {
    lang() {
      if (this.$i18n.locale === "de") {
        return de;
      } else if (this.$i18n.locale === "pl") {
        return pl;
      }

      return en;
    },
    yesterday() {
      let today = new Date();
      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      return yesterday;
    },
    applications() {
      return this.$store.getters["application/list"];
    },
    sort() {
      return this.$store.getters["application/orderBy"];
    },
  },
  created() {
    this.fetchList();
  },
  methods: {
    formatPrice(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    changedDate() {
      this.$store.commit(
        "mission/SET_ANONYMIZED_AVAILABILITY_DATE",
        this.date.toISOString().slice(0, 10)
      );
      this.$emit("date", this.date.toISOString().slice(0, 10));
    },
    resetFilter() {
      this.filters = this.defaultFilters();
      this.$store.commit("app/showNotification", {
        heading: this.$t("pages.common.buttons.questions1"),
        desc: this.$t("pages.common.buttons.questions2"),
        buttons: {
          okay: {
            text: this.$t("pages.common.buttons.questions1"),
            action: () => {
              this.resetFilters = true;
              this.$store.commit("application/setFilters", "");
              this.fetchList();
              return {
                active: false,
                rejected: false,
                expired: false,
                past: false,
              };
              // this.showModel = false;
            },
          },
          cancel: {
            text: this.$t("pages.common.buttons.questions3"),
            action: () => {},
          },
        },
      });
    },
    selectedDate(date) {
      try {
        const today = new Date().toISOString().slice(0, 10);
        if (date.toISOString().slice(0, 10) < today) {
          this.error = this.$t("component.searchCard.beforeError");
          this.$emit("input", false);
        } else {
          this.error = "";
          this.$emit("input", true);
        }
      } catch {
        this.$emit("input", true);
      }
    },
    inputDate(date) {
      this.$store.commit(
          'application/setDate',
          date.toISOString().slice(0, 10)
      );
     this.fetchList();
    },
    filterClose() {
      this.showModel = false;
      this.fetchList();
    },
    fetchList() {
      this.loading = true;
      this.showFilterBox = false;
      this.$store.dispatch("application/list").then((response) => {
        this.loading = false;
      });
    },
    defaultFilters() {
      return {
        active: false,
        rejected: false,
        expired: false,
        past: false,
      };
    },
    filterChanged() {
      let filters = [];
      if (this.filters.active) {
        filters.push("active");
      }

      if (this.filters.rejected) {
        filters.push("rejected");
      }

      if (this.filters.expired) {
        filters.push("expired");
      }

      if (this.filters.past) {
        filters.push("past");
      }
      this.$store.commit("application/setFilters", filters.join(","));
    },
    redirect(application) {
      let routeName = "";

      this.$store.commit("application/setSelected", application);

      switch (application.status) {
        case "nurse":
          routeName = "";
          break;
        case "customer":
          routeName = "RejectApplication";
          break;
        case "another":
          routeName = "SelectionOtherPK";
          break;
        case "applied":
          routeName = "ApplicationProcess";
          break;
        case "accepted":
          routeName = "SelectedApplication";
          break;
        case "expired":
          routeName = "";
          break;
      }

      if (routeName !== "") {
        this.$router.push({ name: routeName });
      }
    },
  },
};
</script>

<style scoped>
.ds-cunstome-picker .input-group-addon {
  left: 0 !important;
}
.search-card__datepicker-input {
  padding-left: 45px;
}
.ds-cunstome-picker .vdp-datepicker {
  width: 100%;
  height: 100%;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  vertical-align: middle;
  position: unset;
}
.ds-cunstome-picker .vdp-datepicker input {
  padding-left: 40px;
}
.ds-cunstome-picker .vdp-datepicker div {
  height: 100%;
}
.custome_check {
  height: 20px;
  width: 20px;
  margin-right: 16px;
}
.custome_check .checkmark {
  width: 100%;
  height: 100%;
}
.bg-lightgrayblack {
  color: white;
  background: #676666;
}
.reset_fill {
  color: #63b15b;
}
.tooltip {
  position: absolute;
  top: -18px;
  opacity: 0;
  margin-left: 5px;
  padding: 10px;
  height: 37px;
  min-width: 184px;
  left: 116px;
  color: white;
  text-align: center;
  background: #63b15b;
  border-radius: 5px;
  white-space: nowrap;
}
</style>
